/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Return an ISO date string that includes the local timezone.
 * @example 2024-01-01T00:00:00+10:00
 */
export const getLocalISOString = (date: Date): string => {
  const offset = date.getTimezoneOffset();
  const offsetSign = offset > 0 ? '-' : '+';

  const offsetHours = (Math.abs(offset) / 60) | 0;
  const offsetMinutes = Math.abs(offset) % 60;

  return (
    date.getFullYear() +
    '-' +
    String(date.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(date.getDate()).padStart(2, '0') +
    'T' +
    String(date.getHours()).padStart(2, '0') +
    ':' +
    String(date.getMinutes()).padStart(2, '0') +
    ':' +
    String(date.getSeconds()).padStart(2, '0') +
    offsetSign +
    String(offsetHours).padStart(2, '0') +
    ':' +
    String(offsetMinutes).padStart(2, '0')
  );
};
